export function googleMapsLocationLink(address: string): string {
  const baseUrl = 'https://www.google.com/maps/search/?api=1'
  const encodedAddress = encodeURIComponent(address)
  return `${baseUrl}&query=${encodedAddress}`
}

export function googleMapsLocationLinkWithCoordinates(
  latitude: number,
  longitude: number,
): string {
  const baseUrl = 'https://www.google.com/maps/search/?api=1'
  return `${baseUrl}&query=${latitude},${longitude}`
}

export function googleMapsDirectionsLink(destination: string): string {
  const baseUrl = 'https://www.google.com/maps/dir/?api=1'
  const encodedDestination = encodeURIComponent(destination)
  return `${baseUrl}&destination=${encodedDestination}`
}

export function googleMapsOpenInMapsLink(address: string): string {
  const baseUrl = 'https://www.google.com/maps/search/?api=1'
  const encodedAddress = encodeURIComponent(address)
  return `${baseUrl}&query=${encodedAddress}`
}
